import { render, staticRenderFns } from "./CombinedResultSubjectReportWidget.vue?vue&type=template&id=1ac096d0"
import script from "./CombinedResultSubjectReportWidget.vue?vue&type=script&lang=js"
export * from "./CombinedResultSubjectReportWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports